// extracted by mini-css-extract-plugin
module.exports = {"preserveOutline":"SaveButton_preserveOutline__2cHjD","button":"SaveButton_button__3PgJA SaveButton_preserveOutline__2cHjD","buttonSvg":"SaveButton_buttonSvg__7h2Sp"};